import React from "react";

const OrderRow = ({ order, openModal }) => {
  const statusColors = {
    Pendiente: "bg-yellow-500/10 text-yellow-400",
    "En Proceso": "bg-blue-500/10 text-blue-400",
    Completado: "bg-green-500/10 text-green-400",
    Cancelado: "bg-red-500/10 text-red-400"
  };

  // Fallback seguro
  const colors = statusColors[order.status] || "bg-gray-500/10 text-gray-400";
  const dotColor = colors.split(" ")[1]; // segunda clase para el punto

  return (
    <tr>
      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">{order.id}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-400">{order.date || "00/00/0000"}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-400">{order.customer || "-"}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-400">{order.total || "$0.00"}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm">
        <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${colors}`}>
          <span className={`mr-1.5 h-2 w-2 rounded-full ${dotColor}`}></span>
          {order.status || "Desconocido"}
        </span>
      </td>
      <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
        <div className="flex justify-end gap-x-2">
          <button onClick={() => openModal(order, "view")} className="p-1 text-gray-400 hover:text-white">👁️</button>
          <button onClick={() => openModal(order, "payment")} className="p-1 text-gray-400 hover:text-white">💲</button>
          <button onClick={() => openModal(order, "status")} className="p-1 text-gray-400 hover:text-white">🔄</button>
        </div>
      </td>
    </tr>
  );
};

export default OrderRow;
